import { createReducer } from 'reduxsauce';
import { REQUEST_LOGIN_CREDENTIALS } from 'actions/Base';

export const INITIAL_STATE = {
};

export const onCreateRequest = () => ({  });
export const onCreateFailure = () => ({  });
export const onCreateSuccess = () => ({  });

export const onResetRequest = () => INITIAL_STATE;

export const ACTION_HANDLERS = {
  [REQUEST_LOGIN_CREDENTIALS.CREATE_REQUEST]: onCreateRequest,
  [REQUEST_LOGIN_CREDENTIALS.CREATE_FAILURE]: onCreateFailure,
  [REQUEST_LOGIN_CREDENTIALS.CREATE_SUCCESS]: onCreateSuccess,
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);
